import { CreateControleMateriaisRequest } from "../../../data/daos/create/create_controle_materiais";
import { ICreateControleMateriaisUseCase } from "../../../presentation/useCases/create/create_controle_materiais_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateControleMateriaisUseCase
 */

export class CreateControleMateriaisUseCase implements ICreateControleMateriaisUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async createControleMateriais(modal: CreateControleMateriaisRequest): Promise<void> {
    await this.repository.postControleMateriaisCreate(modal);
  }
}
